import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import doraMetricsPlugin from '@c2l2c/backstage-plugin-dora-metrics/alpha';
import snykPlugin from 'backstage-plugin-snyk/alpha';
import snykBranchViewPlugin from 'snyk-branch-view';
import databricksDashboardPlugin from 'databricks-dashboard';
import { navModule } from './modules/nav';
import { signInModule } from './modules/sign-in';
import { scmAuthApis } from './modules/scm-auth';
import { serviceGroupCardModule } from './modules/service-group-card';
import { entityNameCardModule } from './modules/entity-name-card';
import { catalogColumnsModule } from './modules/catalog-columns';
import { apiDocsColumnsModule } from './modules/api-docs-columns';
import { themeModule } from './modules/theme';
import {
  techdocsAvailabilityModule,
  techdocsMessagesModule,
} from './modules/techdocs-messages';
import { techdocsGenerationStatusModule } from './modules/techdocs-generation-status';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    signInModule,
    scmAuthApis,
    doraMetricsPlugin,
    snykPlugin,
    snykBranchViewPlugin,
    databricksDashboardPlugin,
    serviceGroupCardModule,
    entityNameCardModule,
    catalogColumnsModule,
    apiDocsColumnsModule,
    themeModule,
    techdocsMessagesModule,
    techdocsAvailabilityModule,
    techdocsGenerationStatusModule,
  ],
});
